import React from "react";
import { Link } from "react-router-dom";
import useUsertype from "../hooks/auth/useUsertype";
import useGetSisfoParentUrl from "../hooks/useGetSisfoParentUrl";
import { useDefaultRoute } from "./Redirector";

interface Props {}

const NoMatch: React.FunctionComponent<Props> = (props) => {
  const defaultRoute = useDefaultRoute();
  const sisfoParentUrl = useGetSisfoParentUrl();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        flexDirection: "column",
      }}
    >
      <h2>Lost?</h2>
      <Link to={"/" + sisfoParentUrl + defaultRoute}>Get Back home</Link>
    </div>
  );
};

export default NoMatch;
